"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("./types");
var mainHostnameFromHostname_1 = __importDefault(require("./mainHostnameFromHostname"));
function clientShortHandNameFromHostname(hostname) {
    var domainName = (0, mainHostnameFromHostname_1.default)(hostname).replace(/\.(lh|no$)/, '');
    var map = {
        aftenbladet: types_1.ClientShortHandName.SA,
        aftenposten: types_1.ClientShortHandName.AP,
        'av-avis': types_1.ClientShortHandName.ASK,
        bedrift: types_1.ClientShortHandName.SCH,
        bt: types_1.ClientShortHandName.BTI,
        bygdanytt: types_1.ClientShortHandName.BYN,
        dinepenger: types_1.ClientShortHandName.DP,
        e24dinepenger: types_1.ClientShortHandName.DP,
        magasinpluss: types_1.ClientShortHandName.MPL,
        strilen: types_1.ClientShortHandName.STR,
        vestnytt: types_1.ClientShortHandName.VNY,
        vg: types_1.ClientShortHandName.VG,
        e24: types_1.ClientShortHandName.E24,
        randaberg24: types_1.ClientShortHandName.RB24,
        bareasane: types_1.ClientShortHandName.BAREASANE,
        oyposten: types_1.ClientShortHandName.OP,
        vektklubb: types_1.ClientShortHandName.VEKTKLUBB,
    };
    return map[domainName];
}
exports.default = clientShortHandNameFromHostname;
//# sourceMappingURL=clientShortHandNameFromHostname.js.map